import React from 'react';
import { Sparkles, Loader2, Heart } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'sparkles' | 'heart';
  text?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  variant = 'default',
  text,
  className = '',
}) => {
  const renderSpinner = () => {
    switch (variant) {
      case 'sparkles':
        return (
          <div className={`${sizeClasses[size]} text-primary-500 animate-spin`}>
            <Sparkles className="w-full h-full" />
          </div>
        );
      
      case 'heart':
        return (
          <div className={`${sizeClasses[size]} text-red-500`}>
            <Heart className="w-full h-full" fill="currentColor" />
          </div>
        );
      
      default:
        return (
          <div className={`${sizeClasses[size]} text-primary-500 animate-spin`}>
            <Loader2 className="w-full h-full" />
          </div>
        );
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-4 ${className}`}>
      {renderSpinner()}
      {text && (
        <p className="text-lg font-medium text-gray-700 dark:text-gray-300 text-center">
          {text}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
